<template>
  <div class="form-group has-label">
    <label>Warengruppen</label>
    <div class="d-flex">
      <multiselect :value="value"
        :options="productCategories"
        track-by="id"
        label="name"
        :allow-empty="true"
        :close-on-select="true"
        :searchable="true"
        :internal-search="false"
        :clear-on-select="false"
        :multiple="true"
        @select="$emit('select', $event)"
        @remove="$emit('remove', $event)"
      >
        <template slot="option" slot-scope="props">
          <span :class="props.option.product_category_id ? 'child-cat' : 'parent-cat'">{{ props.option.name }}</span>
        </template>
      </multiselect>
      <button type="button" class="btn btn-sm btn-danger" style="display: inline-block; margin-bottom: 0;"
        v-show="value.length" @click="$emit('deselectAll')"
      >
        <i class="fa fa-times"></i>
      </button>
    </div>
  </div>
</template>

<script>
export default {
  props: ['initProductCategories', 'value'],
  computed: {
    productCategories () {
      return this.initProductCategories.reduce((sum, category) => {
        sum.push(category)
        sum.push(...category.child_categories)
        return sum
      }, [])
    }
  }
}
</script>

<style lang="scss" scoped>
  .parent-cat {
    font-weight: bold;
  }
  .child-cat {
    margin-left: 24px;
  }
</style>
